import api from "./api";

const doctorService = {};
const endpoint = "/doctors";

doctorService.getDoctors = function () {
  return api.get(endpoint).then((res) => res.data);
};

doctorService.getDoctorDetails = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

export default doctorService;
